import classNames from 'classnames';
import { Component } from 'react';
import { IConnectionState } from '../../../Reducers';
import {
  BUTTON_TEXT_CLASS_NAME,
  DIALOG_CLASS_NAME,
  OVERLAY_CLASS_NAME,
  PRIMARY_BUTTON_CLASS_NAME,
} from '../StartScreen/styles';

interface IReconnectProps {
  attemptReconnect: () => void;
  connectionState: IConnectionState;
}

interface IReconnectState {
  failedAutoConnect: boolean;
}

function OfflineIcon() {
  return (
    <span
      aria-hidden="true"
      className="flex size-[56px] shrink-0 items-center justify-center rounded-full bg-control text-ink-muted"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 20h.01M8.5 16.43a5 5 0 0 1 7 0M5 12.86a10 10 0 0 1 5.17-2.69M19 12.86a10 10 0 0 0-2-1.52M2 8.82a15 15 0 0 1 4.18-2.64M22 8.82a15 15 0 0 0-11.29-3.76M2 2l20 20" />
      </svg>
    </span>
  );
}

function Spinner() {
  return (
    <span
      aria-hidden="true"
      className="size-[56px] shrink-0 animate-spin rounded-full border-4 border-hairline border-t-accent-ring"
    />
  );
}

class Reconnect extends Component<IReconnectProps, IReconnectState> {
  state: IReconnectState = {
    failedAutoConnect: false,
  };
  timeout: NodeJS.Timeout | undefined;
  public render() {
    const { attemptReconnect } = this.props;
    const { failedAutoConnect } = this.state;
    return (
      <div className={classNames(OVERLAY_CLASS_NAME, 'z-60')}>
        <div
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="reconnect-title"
          aria-describedby="reconnect-message"
          className={classNames(DIALOG_CLASS_NAME, 'items-center text-center')}
        >
          {failedAutoConnect ? <OfflineIcon /> : <Spinner />}
          <h2 id="reconnect-title" className="mt-[14px] text-[17px] font-bold">
            {failedAutoConnect ? "Can't connect" : 'Connecting'}
          </h2>
          <span
            id="reconnect-message"
            className="mt-[4px] text-[14px] font-medium text-ink-muted"
          >
            {failedAutoConnect
              ? "The game server isn't responding. Check your connection and try again."
              : 'Reaching the game server…'}
          </span>
          {failedAutoConnect && (
            <button
              autoFocus
              onClick={attemptReconnect}
              className={classNames(
                PRIMARY_BUTTON_CLASS_NAME,
                'mt-[20px] w-full'
              )}
            >
              <span className={BUTTON_TEXT_CLASS_NAME}>Try again</span>
            </button>
          )}
        </div>
      </div>
    );
  }

  public componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  public componentDidMount() {
    if (this.props.connectionState.numRetries === 0) {
      this.props.attemptReconnect();
      this.timeout = setTimeout(() => {
        this.props.attemptReconnect();
        this.setState({ failedAutoConnect: true });
      }, this.props.connectionState.waitFactor);
    }
  }
}

export default Reconnect;
